import { scrollToPartnerForm } from '@shared/components/forms/partner'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { getHeaderActionButton } from '@shared/components/top-menu/shared/header-action-button'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'
import { PagesPath, pagesTitles } from 'data/pages-titles'
import Partners from 'screens/partners'

const PartnersPage: NextPageFC<Empty, PageLayoutOwnProps> = () => Partners()

PartnersPage.layout = PageLayout
PartnersPage.breadcrumb = { title: 'Partners' }
PartnersPage.layoutProps = {
	menuProps: {
		EndAdornment: getHeaderActionButton({
			buttonText: 'Стать партнёром',
			onClick: scrollToPartnerForm,
		}),
	},
}
PartnersPage.breadcrumb = { title: 'Партнёрам' }

PartnersPage.headProps = {
	title: pagesTitles[PagesPath.partners].title,
	description:
		'Партнёрская программа для кредитных брокеров. Зарабатывайте до 60 000 ₽ за сделку. Условия: ✅ от 200 000 до 15 000 000 рублей ✅ без справок и финансовой отчётности ✅ решение за 1–2 дня.',
	ogDescription:
		'Партнёрская программа для кредитных брокеров, физических и юридических лиц. Привлекайте заёмщиков зарабатывайте до 60 000 ₽ за сделку.',
	ogImageName: 'partners.jpg',
}

export default PartnersPage
